"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_TYPES = void 0;
var EXPANDING_CATEGORIES = 'Expanding categories';
var EXPANDING_TAGS = 'Expanding tags';
var EXPANDING_CUSTOM_FIELDS = 'Expanding custom fieldS';
var EVENT_TYPES = exports.EVENT_TYPES = {
  EXPANDING_CATEGORIES: EXPANDING_CATEGORIES,
  EXPANDING_TAGS: EXPANDING_TAGS,
  EXPANDING_CUSTOM_FIELDS: EXPANDING_CUSTOM_FIELDS
};
//# sourceMappingURL=events.js.map